import Login from "./login.jsx";
import ForgetPassword from "./forget.jsx";
import OutlookCallback from "./outlook-callback.jsx";

export { ForgetPassword, OutlookCallback };
export default Login;
